import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tagNav:[],
    meta:{
      title: "",
      keywords: "",
      description: "",
    },
  },
  getters: {
  },
  mutations: {
    sertagNav(state,payload){
      state.tagNav = payload
    },
    setmeta(state,payload){
      console.log(payload,'payload');
      state.meta.title = payload.title
      state.meta.keywords = payload.keywords
      state.meta.description = payload.description || payload.seo_desc 
    },
  },
  actions: {
  },
  modules: {
  }
})
